module.exports = __webpack_public_path__ + "static/media/Sunflower-Village-No-1-Covenants-and-Restrictions.36bbc958.pdf";